import SourceIcon from "@mui/icons-material/Source";

export const JobApplicationSourceIcon = SourceIcon;
